import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../../components/GenericComponent";
import { InputComponent } from "../../../components/InputComponent";
import { useToken } from "../../../components/useToken";
import { PersonaJuridicaService } from "../../../service/personaNatural/PersonaJuridicaService";
import { FileComponent } from "../../../components/FileComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Card } from "primereact/card";
import { Panel } from "primereact/panel";
import { Divider } from "primereact/divider";
import { TabPanel, TabView } from "primereact/tabview";
import { InformacionBVG } from "./InformacionBVG";
import { RepresentanteBVG } from "./RepresentanteBVG";
import { SocAccBVG } from "./SocAccBVG";
import { FinancieraPepBVG } from "./FinancieraPepBVG";
import { AmpliadaBvg } from "./AmpliadaBvg";
import { FormPep } from "../FormPep";
import { Dialog } from "primereact/dialog";
import { FileBvg } from "../../../components/FileBvg";
import { Generico } from "../../../components/Generico";
import { AccionistaSocioBvg } from "./AccionistaSocioBvg";
import { ClientepjBvg } from "../../../models/ClientePjBvg";
import { VinculacionBvg } from "../fun/VinculacionBvg";

export const PersonaJuridicaBVG = () => {
    const generic = new GenericComponent();
    const { accionesTbl } = Generico();
    const omodel = new ClientepjBvg();
    const [registros, setRegistros] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [cliente, setCliente] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const juridicoSrv = new PersonaJuridicaService();
    const [permss, setPermss] = useState(null);
    const { getPerss, getRol, getInfo, removeKey } = useToken();
    const [siCliente, setSiCliente] = useState(false);
    const [urls, setUrls] = useState();
    const [urlsPep, setUrlsPep] = useState();
    const [clienteId, setClienteId] = useState(null);
    const [dialogCliente, setDialogCliente] = useState(false);
    const [hayPep, setHayPep] = useState(false);
    const [pepEstado, setPepEstado] = useState(null);
    const [dialogSubir, setDialogSubir] = useState(false);
    const [dialogSubirPep, setDialogSubirPep] = useState(false);
    const [dialogAccionista, setDialogAccionista] = useState(false);
    const toast = useRef(null);
    const [fpendiente, setFpendiente] = useState(null);
    const [estados, setEstados] = useState(null);
    const filters = [fpendiente, estados];
    const [opcion, setOpcion] = useState(null);
    const [hayTercero, setHayTercero] = useState(false);
    const [vinEstado, setVinEstado] = useState(null);
    const [urlsVin, setUrlsVin] = useState(null);
    const [dialogVinculacion, setDialogVinculacion] = useState(false);
    const { dialogInstruccion, setdialogIns } = FileComponent({ generic, tipo: 'clipj', toast, permss, id: cliente?.id });
    const { table, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers: registros, omodel, generic, permss, id: cliente?.id, filters });

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/persona-juridica-bvg',
            urlDownload: 'ficha/persona-juridica-bvg/descarga',
            urlUpload: 'ficha/persona-juridica-bvg/store',
            udelete: 'ficha/persona-juridica-bvg/eliminar-anexo',
            uactual: 'ficha/persona-juridica-bvg/editar',
            uenviar: 'ficha/persona-juridica-bvg/enviar',
            uaprobar: 'ficha/persona-juridica-bvg/aprobar',
            urlGenerar: 'ficha/persona-juridica-bvg/generar-consulta',
        });
        setUrlsPep({
            urlListado: 'ficha/pep-ficha',
            urlDownload: 'ficha/pep-ficha/descarga',
            urlUpload: 'ficha/pep-ficha/store',
            urlVerificacion: 'ficha/pep-ficha',
            udelete: 'ficha/pep-ficha/eliminar-anexo',
            uactual: 'ficha/pep-ficha/editar',
            uenviar: 'ficha/pep-ficha/enviar',
            uaprobar: 'ficha/pep-ficha/aprobar',
            urlGenerar: 'ficha/pep-ficha/generar-consulta',
        });
        setUrlsVin({
            urlListado: 'ficha/vinculacion',
            urlDownload: 'ficha/vinculacion/descarga',
            urlUpload: 'ficha/vinculacion/store',
            udelete: 'ficha/vinculacion/eliminar-anexo',
            uactual: 'ficha/vinculacion/editar',
            uenviar: 'ficha/vinculacion/enviar',
            uaprobar: 'ficha/vinculacion/aprobar',
        });
        setSiCliente(getPerss() !== undefined);

        if (getPerss() === undefined) {
            loadLazyData();
        }
        else {
            setPermss(getPerss());
            if (getInfo('oid')) {
                confirmCarga();
            } else {
                editFicha(false);
            }
        }
    }, [lazyParams]);

    const confirmCarga = () => {
        const message = 'Se ha detectado un formulario anterior ingresado, ¿Quiere recuperar la información?';
        confirmDialog({
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            style: { maxWidth: '400px' },
            accept: () => editFicha(true),
            reject: () => {
                removeKey('oid');
                editFicha(false);
            }
        });
    }

    const editFicha = (cargar = false) => {
        if (catalogos === null) {
            juridicoSrv.newCliente({ iniciar: 1, cargar: cargar }).then(res => {
                setCatalogos(res.data.cats);
                setClienteId(res.data.clienteId ?? null);
                setDialogCliente(true);
                setCliente(null);
                setActiveIndex(0);
                setdialogIns(true);
                if (res.data.codigo) {
                    nuevoCliente({
                        id: res.data.codigo,
                        hay_pep: res.data.hay_pep,
                        pid: res.data.pid,
                        estado_pep: res.data.estado_pep,
                        hay_tercero: res.data.hay_tercero,
                        vid: res.data.vid,
                        estado_tercero: res.data.estado_tercero
                    });
                }
            }).finally(() => {
                setLoading(false);
                if (getInfo('oid')) {
                    removeKey('oid');
                    confirmacion();
                }
            });
        }
        else {
            setDialogCliente(true);
            setActiveIndex(0);
            setdialogIns(true);
        }
    };

    const confirmacion = () => {
        const message = omodel.confirmacionBVG;
        confirmDialog({
            message: message,
            header: 'Declaración',
            icon: 'pi pi-info-circle',
            acceptLabel: 'Aceptar',
            style: { maxWidth: '400px' },
            accept: () => { },
            footer: (options) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button label="Aceptar" icon="pi pi-check" onClick={options.accept} autoFocus />
                    </div>
                );
            }
        });
    }

    const loadLazyData = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        juridicoSrv.getCliente({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
                setFpendiente(res.data.cats.pendiente);
                setEstados(res.data.cats.estados);
            }
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el formulario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteCliente()
        });
    }

    const deleteCliente = () => {
        juridicoSrv.eliminarCliente(cliente.id).then(res => {
            if (!siCliente) {
                loadLazyData();
            }
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const openNew = () => {
        setDialogCliente(true);
        setCliente(null);
        setdialogIns(true);
        setHayTercero(false);
        setHayPep(false);
    }

    const nuevoCliente = (nuevo) => {
        const _cliente = cliente ?? {};
        if (nuevo) {
            if (nuevo?.id !== undefined) _cliente.id = nuevo.id;
            if (nuevo?.representante !== undefined) _cliente.representante = nuevo.representante;
            if (nuevo?.razon_social !== undefined) _cliente.razon_social = nuevo.razon_social;
            // Pep
            if (nuevo?.pid !== undefined) _cliente.pid = nuevo.pid;
            if (nuevo?.hay_pep !== undefined) _cliente.hay_pep = nuevo.hay_pep;
            if (nuevo?.estado_pep !== undefined) setPepEstado(nuevo.estado_pep);
            // Vinculación terceros
            if (nuevo?.vid !== undefined) _cliente.vid = nuevo.vid;
            if (nuevo?.hay_tercero !== undefined) _cliente.hay_tercero = nuevo.hay_tercero;
            if (nuevo?.estado_tercero !== undefined) setVinEstado(nuevo.estado_tercero);
        }
        setHayPep(_cliente.hay_pep === true);
        setHayTercero(_cliente.hay_tercero === true);
        // Si cliente es null, y al procesar las propiedades, tenemos {}, asignamos null en vez de {}
        setCliente(Object.keys(_cliente).length === 0 ? null : _cliente);
    }

    const regresar = () => {
        setActiveIndex(0);
        setDialogCliente(false);
        if (!siCliente) {
            loadLazyData();
        }
    }

    const handleNext = () => {
        if (activeIndex < 7) {
            setActiveIndex(activeIndex + 1);
        }
    };

    const handlePrev = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    };

    const nextPrev = (btn = true) => {
        const btnNext = btn ? <Button label="Siguiente" type="submit" icon="pi pi-chevron-right" /> :
            <Button label="Siguiente" type="button" icon="pi pi-chevron-right" onClick={e => { handleNext(); }} />;
        return (
            <div className="formgrid grid">
                <div className="field col">
                    <Button label="Anterior" icon="pi pi-chevron-left" type="button" onClick={e => handlePrev()} />
                </div>
                <div className="field col">
                    {btnNext}
                </div>
            </div>
        )
    }

    const archivos = () => {
        setDialogSubir(true);
    }

    const reiniciar = () => {
        if (!siCliente) {
            loadLazyData();
        }
        setDialogCliente(false);
        setDialogSubirPep(false);
        setDialogSubir(false);
        setDialogVinculacion(false);
    }

    const reiniciarPep = (ban) => {
        setActiveIndex(4);
        if (ban && ban === 'ENVIADO') {
            setPepEstado('ENVIADO');
        }
    }

    const archivosPep = () => {
        setDialogSubirPep(true);
    }

    const siOpcion = (strOpcion) => {
        return opcion === 'PRELAFIT' || opcion?.includes(strOpcion);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && (!cliente?.nemonico || cliente.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        if (siOpcion('form-juridica-bvg-anexos') && permss?.consultar)
            items.push({ label: 'Anexos formulario', icon: 'pi pi-clone', command: () => { archivos() } });
        if (siOpcion('form-juridica-bvg-anexos') && permss?.consultar && cliente?.pid)
            items.push({ label: 'Anexos formulario(PEP)', icon: 'pi pi-reddit', command: () => { archivosPep() } });
        if (permss?.consultar && cliente?.vid)
            items.push({ label: 'Anexos formulario - Vinculación', icon: 'pi pi-discord', command: () => { setDialogVinculacion(true) } });
        if (permss?.consultar && cliente?.acc_pep === true) items.push({ label: 'Gestión de accionistas y anexos', icon: 'pi pi-briefcase', command: () => { setDialogAccionista(true) } });
        if (permss?.eliminar && (!cliente?.nemonico || cliente.nemonico !== 'FINALIZADO'))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const reiniciarVinculacion = (est) => {
        if (!siCliente) {
            loadLazyData();
        }
        setActiveIndex(4);
        nuevoCliente({ estado_tercero: est });
    }

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            {!dialogCliente && !siCliente && <>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)}
                    end={generic.rightToolbarTemplate(registros, omodel, 'Reporte_persona_juridica', 'LISTADO PERSONA JURIDICA')}></Toolbar>
                <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                    {table({ action01: accionesTbl, reg: setCliente, items: itemsMenu() })}
                </Card></>
            }
            {dialogCliente &&
                <Panel header='INFORMACIÓN DE PERSONAS JURÍDICA: Política "Conozca Cliente, Proveedor, Accionista"' style={{ maxWidth: '100%', margin: 'auto' }}>
                    {omodel.titleBVG}
                    <Divider />
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="Sección 1">
                            <InformacionBVG id={cliente?.id ?? clienteId} siCliente={siCliente ?? clienteId} next={handleNext} permss={permss} catalogos={catalogos} nuevoCliente={nuevoCliente}
                                toast={toast} seccion="seccion1" generic={generic} />
                        </TabPanel>

                        <TabPanel header="Sección 2" disabled={cliente == null}>
                            <RepresentanteBVG generic={generic} nextPrev={nextPrev} handleNext={handleNext} handlePrev={handlePrev} permss={permss} cliente={cliente} catalogos={catalogos} toast={toast}
                                seccion="seccion2" nuevoCliente={nuevoCliente} id={cliente?.id} />
                        </TabPanel>

                        <TabPanel header="Sección 3" disabled={cliente == null}>
                            <SocAccBVG generic={generic} nextPrev={nextPrev} handleNext={handleNext} handlePrev={handlePrev} permss={permss} cliente={cliente} catalogos={catalogos} toast={toast}
                                seccion="seccion3" nuevoCliente={nuevoCliente} id={cliente?.id} />
                        </TabPanel>

                        <TabPanel header="Sección 4" disabled={cliente == null}>
                            <FinancieraPepBVG generic={generic} nextPrev={nextPrev} handleNext={handleNext} handlePrev={handlePrev} permss={permss} cliente={cliente} catalogos={catalogos} toast={toast}
                                seccion="seccion4" nuevoCliente={nuevoCliente} id={cliente?.id} />
                        </TabPanel>

                        <TabPanel header="Sección 5 (final)" disabled={cliente == null}>
                            <AmpliadaBvg generic={generic} id={cliente?.id ?? clienteId} permss={permss} nextPrev={nextPrev} next={handleNext} catalogos={catalogos} toast={toast}
                                setDialogClientepn={setDialogCliente} seccion="seccion5" tipo='juridicaBvg' cancelar={getPerss() === undefined} urls={urls} estado={cliente?.nemonico}
                                reiniciar={reiniciar} />
                        </TabPanel>

                        {hayPep && <TabPanel header={(pepEstado === 'ENVIADO' || pepEstado === 'FINALIZADO') ? "Sección PEP´s Representante Legal Receptado" : "Sección PEP´s Representante Legal"}
                            disabled={cliente == null || !cliente?.id || ((pepEstado === 'ENVIADO' || pepEstado === 'FINALIZADO') && siCliente)}>
                            <FormPep tipo="juridicaBvg" idp={cliente?.id} id={cliente?.pid} version={cliente?.pep_version} permss={permss} toast={toast} urls={urls} reiniciar={reiniciarPep} setDialogClientepn={setDialogCliente} />
                        </TabPanel>}

                        {hayTercero && <TabPanel header={(vinEstado === 'ENVIADO' || vinEstado === 'FINALIZADO') ? "Formulario de vinculación receptado" : "Vinculación con terceros"}
                            disabled={cliente == null || !cliente?.id || ((vinEstado === 'ENVIADO' || vinEstado === 'FINALIZADO') && siCliente)}>
                            <VinculacionBvg generic={generic} nextPrev={nextPrev} next={handleNext} handlePrev={handlePrev} permss={permss} cliente={cliente} catalogos={catalogos} toast={toast}
                                seccion="seccion8" nuevoCliente={nuevoCliente} id={cliente?.vid} idp={cliente?.id} tipo="clientePjBvg" urls={urlsVin} reiniciar={reiniciarVinculacion} />
                        </TabPanel>}
                    </TabView>
                </Panel>
            }
            {dialogCliente && !siCliente && <><br /><Button label="Regresar" icon="pi pi-replay" onClick={regresar} /></>}
            {dialogInstruccion('Instrucciones', omodel.mensajeBVG)}

            <Dialog visible={dialogSubir} header={"Gestión de anexos: " + cliente?.razon_social} modal className="p-fluid modal-ssize" onHide={e => setDialogSubir(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="juridicaBvg" urls={urls} idp={cliente?.id} toast={toast} permss={permss} estado={cliente?.nemonico} reiniciar={reiniciar}
                    setDialogSubir={setDialogSubir} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogSubirPep} header={"Gestión de anexos (PEP): " + cliente?.razon_social} modal className="p-fluid modal-ssize" onHide={e => setDialogSubirPep(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="juridicaBvg" urls={urlsPep} idp={cliente?.pid} toast={toast} permss={permss} estado={cliente?.estado_pep} reiniciar={reiniciar}
                    setDialogSubir={setDialogSubirPep} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogVinculacion} header={"Gestión de anexos (Vinculación): " + cliente?.nombre_completo} modal className="p-fluid modal-ssize"
                onHide={e => setDialogVinculacion(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="clientePjBvg" urls={urlsVin} idp={cliente?.vid} toast={toast} permss={permss} estado={cliente?.estado_tercero}
                    reiniciar={reiniciar} setDialogSubir={setDialogVinculacion} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogAccionista} header={"Gestión de accionistas y anexos: " + cliente?.razon_social} modal className="p-fluid modal-ssize"
                onHide={e => setDialogAccionista(false)} style={{ width: '800px' }}>
                <AccionistaSocioBvg idp={cliente?.id} permss={permss} catalogos={null} toast={toast} origen={true} />
            </Dialog>
        </>
    )
}
